import React, { Component, useState, useEffect } from "react";
import { connect } from "react-redux";
// import {classNames} from "Constants"
import AdvertisementinsightInside from "AdvertisementinsightInsideSets";
import { fetchadvertisementanalyticCounts } from "AdvertisementinsightActions";

const Analytics = (props) => {
  useEffect(() => {
    // didmount
    props.fetchadvertisementanalyticCounts(props.session);
    return () => {};
  }, []);

  return <AdvertisementinsightInside />;
};

function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    // advAnalyticsMenu, // cards
  };
}

export default connect(mapStateToProps, { fetchadvertisementanalyticCounts })(
  Analytics
);
